module.exports = __webpack_public_path__ + "media/images/favorite-big-icon-e94955f6635c4040c9b76006628fd030.png";